// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"e36d684a","253":"6ba92c30","371":"3a46e41b","431":"d3675b56","604":"aef27c32","624":"c3f3f79c","802":"28a45b0f"}[chunkId] + ".chunk.js";
};